/**
 * O BTG só devolve `paymentDate` (sem hora). A hora vem embutida no endToEndId do PIX:
 * E + ISPB (8 dígitos) + AAAAMMDDHHmm (UTC) + sufixo.
 */
export const parseEndToEndDate = (endToEndId?: string | null): Date | null => {
  const match = endToEndId?.match(/^E\d{8}(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})/);
  if (!match) return null;

  const [, year, month, day, hour, minute] = match;
  const date = new Date(
    Date.UTC(Number(year), Number(month) - 1, Number(day), Number(hour), Number(minute))
  );

  return Number.isNaN(date.getTime()) ? null : date;
};

/** Data e hora do PIX no BTG; sem endToEndId, cai para a data (`paymentDate`) sem hora. */
export const formatBtgDateTime = (
  paymentDate?: string | null,
  endToEndId?: string | null
): string | null => {
  const fromEndToEnd = parseEndToEndDate(endToEndId);
  if (fromEndToEnd) {
    return fromEndToEnd.toLocaleString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  }

  if (!paymentDate) return null;
  return new Date(paymentDate).toLocaleDateString("pt-BR", { timeZone: "UTC" });
};
